import { toast } from 'react-toastify';

import { CopyStrategyConfigDto, updateStrategy } from 'api/copyBotApi';
import { useCopyBotAuth } from 'hooks';
import { store } from 'store';

export const useSaveSettings = () => {
  const { account } = store.web3Store;
  const { portfolio, updatePortfolioFromWallet } = store.portfolioStore;
  const { getAccessToken, clearAccessToken } = useCopyBotAuth();

  const saveSettings = async (strategyConfig: CopyStrategyConfigDto) => {
    if (!account || !portfolio) return false;

    try {
      const token = await getAccessToken(account);
      const wallet = await updateStrategy(account, strategyConfig, token);

      await updatePortfolioFromWallet(wallet);
      toast.success('Settings saved');
      return true;
    } catch (err: any) {
      if (err?.response?.status === 401) {
        clearAccessToken(account);
      }
      console.error('Failed to save settings:', err);
      toast.error('Failed to save settings');
      return false;
    }
  };

  return saveSettings;
};
